export default {
    development: 'http://localhost:3000',
    local: 'http://localhost:3000',
    production: 'https://s3-eu-west-1.amazonaws.com/livebuzz-web-modules/releases',
    staging: 'https://s3-eu-west-1.amazonaws.com/livebuzz-web-modules/releases',
};
